import {twMerge} from '@sdox/utils'

export interface QuoteProps {
  text: string
  className?: string
  contentClassName?: string
}

export const Quote = ({text, className, contentClassName: pClassName}: QuoteProps) => (
  <div className={className}>
    <p
      className={twMerge(
        'max-w-text hyphens-auto break-words px-spacing-20 py-spacing-8 text-p1',
        'border-l-1 border-outline-secondary',
        pClassName,
      )}
    >
      {text}
    </p>
  </div>
)
